import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { HttpModule } from '@angular/http';

import { AdminComponent } from './admin.component';
import { ClientsComponent } from './clients/clients.component';
import { TemplatesComponent } from './templates/templates.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { HelpComponent } from './help/help.component';
import { AdminRouteModule } from './admin.routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SidebarAdminComponent } from './sidebar-admin/sidebar-admin.component';
import { SharedModule } from '../shared/shared.module';
import { AdminService } from './admin.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { BlockService } from '../services/block.service';

import { ClientEditComponent } from './clients/client-edit/client-edit.component';
import { ClientDashboardComponent } from './clients/client-dashboard/client-dashboard.component';
import { ClientService } from '../services/client.service';

import { ElementsComponent } from './templates/elements/elements.component';
import { ElementEditComponent } from './templates/elements/element-edit/element-edit.component';
import { ElementService } from '../services/element.service';

import { GroupsComponent } from './groups/groups.component';
import { GroupService } from '../services/group.service';
import { GroupEditComponent } from './groups/group-edit/group-edit.component';
import { GroupDashboardComponent } from './groups/group-dashboard/group-dashboard.component';

import { QuickDesignsComponent } from './templates/quick-designs/quick-designs.component';
import { QuickDesignEditComponent } from './templates/quick-designs/quick-design-edit/quick-design-edit.component';
import { QuickDesignBuildComponent } from './templates/quick-designs/quick-design-build/quick-design-build.component';

import { Select2Module } from 'ng2-select2';
import { QuickDesignService } from '../services/quick-deisgn.service';
import { SettingAdminComponent } from './setting-admin/setting-admin.component';
import { MediaAttributesComponent } from './setting-admin/media-attributes/media-attributes.component';
import { DepartmentsComponent } from './setting-admin/departments/departments.component';
import { MediaAttributeService } from '../services/media-attribute.service';
import { DepartmentService } from '../services/department.service';
import { MastersComponent } from './templates/masters/masters.component';
import { MasterEditComponent } from './templates/masters/master-edit/master-edit.component';


import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { MasterService } from '../services/master.service';
import { ElementHtmlComponent } from './templates/elements/element-html/element-html.component';
import { StylesComponent } from './styles/styles.component';
import { StyleDashboardComponent } from './styles/style-dashboard/style-dashboard.component';
import { StyleEditComponent } from './styles/style-edit/style-edit.component';
import { StyleService } from '../services/style.service';
import { ClientGalleryComponent } from './clients/client-gallery/client-gallery.component';
import { StorageService } from '../services/storage.service';

import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { UsersComponent } from './users/users.component';
import { TrainingVideosComponent } from './help/training-videos/training-videos.component';
import { SupportComponent } from './help/support/support.component';
import { FaqsComponent } from './help/faqs/faqs.component';
import { TrainingVideosEditComponent } from './help/training-videos/training-videos-edit/training-videos-edit.component';
import { TrainingVideosDashboardComponent } from './help/training-videos/training-videos-dashboard/training-videos-dashboard.component';
import { FaqDashboardComponent } from './help/faq-dashboard/faq-dashboard.component';
import { FaqEditComponent } from './help/faq-edit/faq-edit.component';
import { IconsComponent } from './icons/icons.component';
import { IconsEditComponent } from './icons/icons-edit/icons-edit.component';
import { IconsDashboardComponent } from './icons/icons-dashboard/icons-dashboard.component';
import { IconService } from '../services/icon.service';
import { FaqCategoryEditComponent } from './help/faq-category-edit/faq-category-edit.component';
import { FaqCategoryDashboardComponent } from './help/faq-category-dashboard/faq-category-dashboard.component';
import { FaqCategoryService } from '../services/faqcategory.service';
import { AnalyticUserLogsComponent } from './analytics/analytic-user-logs/analytic-user-logs.component';
import { AnalyticTemplateUsageComponent } from './analytics/analytic-template-usage/analytic-template-usage.component';

import { ChangelogDashboardComponent } from './help/changelog-dashboard/changelog-dashboard.component';
import { ChangelogEditComponent } from './help/changelog-edit/changelog-edit.component';
import { ChangelogService } from '../services/changelogs.service';
import { ImageLibraryService } from '../shared/imagelibrary.service';
import { ImageLibraryComponent } from './../image-library/image-library.component';

import { WhiteBlackListingComponent } from './setting-admin/white-black-listing/white-black-listing.component';
import { SettingService } from '../services/setting.service';

import { StringFilterPipe } from '../pipes/string-filter.pipe';

import {NgxPaginationModule} from 'ngx-pagination';

import { SubgroupsComponent } from './subgroups/subgroups.component';
import { SubgroupsDashboardComponent } from './subgroups/subgroups-dashboard/subgroups-dashboard.component';
import { SubgroupsEditComponent } from './subgroups/subgroups-edit/subgroups-edit.component';
import { SubgroupService } from '../services/subgroup.service';
import { WebsiteService } from '../services/website.service';
import { WebsitesComponent } from './websites/websites.component';
import { WebsiteDashboardComponent } from './websites/website-dashboard/website-dashboard.component';
import { WebsiteEditComponent } from './websites/website-edit/website-edit.component';
import { WebsiteLogsComponent } from './websites/website-logs/website-logs.component';
import { VaultWhiteListingComponent } from './setting-admin/vault-white-listing/vault-white-listing.component';
import { AdminBlacklistsComponent } from './admin-blacklists/admin-blacklists.component';
import { BlacklistsEditComponent } from './admin-blacklists/blacklists-edit/blacklists-edit.component';
import { BlacklistsDashboardComponent } from './admin-blacklists/blacklists-dashboard/blacklists-dashboard.component';
import { BlacklistService } from '../services/blacklist.service';

@NgModule({
  declarations: [
    AdminComponent,
    ClientsComponent,
    TemplatesComponent,
    AnalyticsComponent,
    HelpComponent,
    DashboardComponent,
    SidebarAdminComponent,
    ClientEditComponent,
    ElementsComponent,
    QuickDesignsComponent,
    ClientDashboardComponent,
    ElementEditComponent,
    QuickDesignEditComponent,
    GroupsComponent,
    GroupEditComponent,
    GroupDashboardComponent,
    QuickDesignBuildComponent,
    SettingAdminComponent,
    MediaAttributesComponent,
    DepartmentsComponent,
    MastersComponent,
    MasterEditComponent,
    ElementHtmlComponent,
    StylesComponent,
    StyleDashboardComponent,
    StyleEditComponent,
    ClientGalleryComponent,
    UsersComponent,
    TrainingVideosComponent,
    TrainingVideosEditComponent,
    TrainingVideosDashboardComponent,
    FaqsComponent,
    SupportComponent,
    FaqDashboardComponent,
    FaqEditComponent,
    IconsComponent,
    IconsEditComponent,
    IconsDashboardComponent,
    FaqCategoryEditComponent,
    FaqCategoryDashboardComponent,
    AnalyticUserLogsComponent,
    AnalyticTemplateUsageComponent,
    ChangelogDashboardComponent,
    ChangelogEditComponent,
    StringFilterPipe,
    WhiteBlackListingComponent,
    SubgroupsComponent,
    SubgroupsDashboardComponent,
    SubgroupsEditComponent,
    WebsitesComponent,
    WebsiteDashboardComponent,
    WebsiteEditComponent,
    WebsiteLogsComponent,
    VaultWhiteListingComponent,
    AdminBlacklistsComponent,
    BlacklistsDashboardComponent,
    BlacklistsEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    AdminRouteModule,
    SharedModule,
    BrowserAnimationsModule,
    Select2Module,
    NgxPaginationModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.rectangleBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
      backdropBorderRadius: '0',
      primaryColour: '#FFF',
      secondaryColour: '#FFF',
      tertiaryColour: '#FFF'
    }),
    MalihuScrollbarModule.forRoot()
  ],
  providers: [
    AdminService,
    ClientService,
    GroupService,
    ElementService,
    BlockService,
    QuickDesignService,
    MediaAttributeService,
    DepartmentService,
    MasterService,
    StyleService,
    StorageService,
    IconService,
    FaqCategoryService,
    ChangelogService,
    ImageLibraryService,
    SettingService,
    SubgroupService,
    WebsiteService,
    BlacklistService
  ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts